import * as React from 'react';
import {Clickable} from 'src/designSystem2021Components/text-v2';
import {backgroundImage} from 'src/utils/css';
import classify from 'src/utils/classify';

import css from './branding-preview.css';
import maincss from 'src/components/agency-onboard/agency-onboard.css';


export type PreviewProps = {
  brandColor?: string;
  buttonColor?: string;
  logo?: string;
};

export const Preview = ({brandColor, buttonColor, logo}: PreviewProps) => {
  const boxStyle = {
    borderTopColor: brandColor,
  } as const;

  const solidButtonStyle = {
    borderColor: buttonColor,
    backgroundColor: buttonColor,
  } as const;
  const clearButtonStyle = {
    borderColor: buttonColor,
    color: buttonColor,
  } as const;

  return (
    <>
      <Clickable>Preview</Clickable>
      <div className={css.previewBox} style={boxStyle}>
        <div className={css.logoSection}>
          {logo ? (
            // @ts-expect-error - TS2322 - Type '{ backgroundImage: string; } | null | undefined' is not assignable to type 'CSSProperties | undefined'.
            <div className={css.previewLogo} style={backgroundImage(logo)} />
          ) : (
            <div className={css.previewLogoBlank}>Logo</div>
          )}
          <div className={css.previewTextSection}>
            <Clickable className={classify(css.previewText, maincss.text)}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Clickable>
          </div>
        </div>
        <div className={css.buttonRow}>
          <div className={css.previewButtonWhite} style={clearButtonStyle}>
            Button - Empty
          </div>
          <div className={css.previewButton} style={solidButtonStyle}>
            Button - Filled
          </div>
        </div>
      </div>
    </>
  );
};
